import React, { useId } from 'react';

/**
 * Checkbox with title + description in a bordered card; accent color orange.
 */
function CheckboxOptionCard({
  checked,
  onChange,
  title,
  description,
  className = '',
  id,
}) {
  const autoId = useId();
  const inputId = id ?? autoId;

  return (
    <label
      htmlFor={inputId}
      // Checked, the card is outlined in the accent colour, as the design draws a
      // selected option.
      className={`flex gap-3 items-start border rounded p-4 cursor-pointer transition-colors ${
        checked ? 'border-[#F99600]' : 'border-gray-200 hover:bg-gray-50'
      } ${className}`}
    >
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{ accentColor: '#F99600' }}
        className="mt-1 h-4 w-4 shrink-0 rounded border-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F99600] focus-visible:ring-offset-0"
      />
      <div className="flex flex-col min-w-0">
        <span className="text-sm font-semibold text-gray-800">{title}</span>
        {description != null && (
          <span className="text-sm text-gray-500">{description}</span>
        )}
      </div>
    </label>
  );
}

export default CheckboxOptionCard;
